import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { INoticeListResponse } from '@bciti/types';
import { PaginatedResult } from 'src/app/interfaces/global/global.model';

@Injectable({
    providedIn: 'root',
})
export abstract class NoticesService {
    abstract getStats(): Observable<any[]>;
    abstract getNotices(): Observable<PaginatedResult<INoticeListResponse>>;
}
